import React, { useCallback } from 'react'
import { Button } from 'antd'

import { PERMISSIONS } from '../../../common/constants'
import idPropType from '../../../common/prop-types/id-prop-type'

import { PermissionGuard } from '../../../account/components/sections'
import { useDeleteSopMutation } from '../../hooks'

const SopsTableActionColumn = ({ id }) => {
  const [deleteSop, { isLoading }] = useDeleteSopMutation()
  const handleDelete = useCallback(() => deleteSop(id), [deleteSop, id])

  return (
    <PermissionGuard permissions={PERMISSIONS.SOP.DELETE}>
      <Button onClick={handleDelete} loading={isLoading}>
        Delete
      </Button>
    </PermissionGuard>
  )
}

SopsTableActionColumn.propTypes = {
  id: idPropType.isRequired,
}

export default SopsTableActionColumn
